// src/components/Pages/AuthCallback.jsx
import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';

const AuthCallback = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const handleCallback = async () => {
      const code = searchParams.get('code');
      const state = searchParams.get('state');
      const error = searchParams.get('error');

      console.log('Auth callback received:', { code, state, error });

      if (error) {
        console.error('OAuth error:', error);
        // Send error message to opener window
        window.opener?.postMessage({
          type: 'OAUTH_COMPLETE',
          success: false,
          error: error
        }, window.location.origin);
        return;
      }

      if (code && state) {
        try {
          console.log('Exchanging code for tokens...');
          
          // Send code and state to backend for processing
          const response = await axios.get('/api/auth/frontend-callback', {
            params: { code, state }
          });

          console.log('Backend response:', response.data);

          if (response.data.success) {
            // Send success message to opener window
            window.opener?.postMessage({
              type: 'OAUTH_COMPLETE',
              success: true,
              platform: response.data.accountData?.platform,
              accountData: response.data.accountData
            }, window.location.origin);
          } else {
            window.opener?.postMessage({
              type: 'OAUTH_COMPLETE',
              success: false,
              error: response.data.error
            }, window.location.origin);
          }
        } catch (error) {
          console.error('Token exchange failed:', error);
          window.opener?.postMessage({
            type: 'OAUTH_COMPLETE',
            success: false,
            error: error.response?.data?.error || 'Authentication failed'
          }, window.location.origin);
        }
      } else {
        window.opener?.postMessage({
          type: 'OAUTH_COMPLETE',
          success: false,
          error: 'Missing code or state parameter'
        }, window.location.origin);
      }

      // Close the window after a short delay
      setTimeout(() => {
        window.close();
      }, 1000);
    };

    handleCallback();
  }, [searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#FD5F20] mx-auto"></div>
        <p className="mt-4 text-gray-600">Completing authentication...</p>
        <p className="text-sm text-gray-500 mt-2">This window will close automatically</p>
      </div>
    </div>
  );
};

export default AuthCallback;